import { Component } from "react";
import { Provider } from "react-redux";
import createHistory from "history/createBrowserHistory";
import NotificationSystem from "react-notification-system";
import { IntlProvider } from "react-intl";
import AuthRouter from "../routes";
import { notificationManagerInstance, notificationStyles } from "../utils/notificationManager";
import configureStore from "../redux/configureStore";
import ReactGA from "react-ga";
global.appVersion = process.env.REACT_APP_VERSION;

export const store = configureStore({});

const intlFormats = {
  date: {
    short: {
      day: "numeric",
      month: "long",
    },
  },
  time: {
    short: {
      hour: "2-digit",
      minute: "2-digit",
    },
  },
};

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_KEY);

export const history = createHistory();

history.listen((location, action) => {
  ReactGA.set({ page: location.pathname });
  ReactGA.pageview(location.pathname);
});

export default class Root extends Component {
  captureNotificationSystem = instance => {
    notificationManagerInstance.setNotificationSystem(instance);
  };

  render() {
    return (
      <Provider store={store}>
        <IntlProvider locale="en-AU" formats={intlFormats}>
          <span>
            <NotificationSystem
              ref={this.captureNotificationSystem}
              style={notificationStyles}
            />
            <AuthRouter history={history} />
          </span>
        </IntlProvider>
      </Provider>
    );
  }
}
